module.exports = "/_next/static/images/15916bdc4aee064ae3c92aadd0a4be22-open-graph-logo-large.jpg.webp";